export const captureVideoFrame = (video: HTMLVideoElement, _format?: string, _quality?: number) => {
  const format = _format || 'jpeg';
  const quality = _quality || 0.92;

  if (!video || (format !== 'png' && format !== 'jpeg')) {
    return;
  }
  const canvas = document.createElement('canvas');
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const context = canvas.getContext('2d');
  if (context) {
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataUri = canvas.toDataURL('image/' + format, quality);
    const data = dataUri.split(',')[1];
    const mimeType = dataUri.split(';')[0].slice(5);
    const bytes = window.atob(data);
    const buf = new ArrayBuffer(bytes.length);
    const arr = new Uint8Array(buf);
    for (let i = 0; i < bytes.length; i++) {
      arr[i] = bytes.charCodeAt(i);
    }
    const blob = new Blob([arr], { type: mimeType });
    return { blob: blob, dataUri: dataUri, format: format };
  }
};

export const secondsToTime = (seconds: number): string => {
  return new Date(seconds * 1000).toISOString().substr(14, 5);
};

export const humanizeString = (str: string) => {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, function (m) {
      return m.toUpperCase();
    });
};

export const getFullName = (firstName?: string, lastName?: string) => {
  return firstName && lastName ? `${firstName} ${lastName}` : 'N/A';
};

export const ellipseText = (text: string, count = 30) => {
  if (text) {
    return text.length > count ? text.substring(0, count) + '...' : text;
  }
  return '';
};

export interface IMetaData {
  width: number;
  height: number;
}

const computedWidth = (width: number, height: number) => (width * 250) / height;

export const getImageWidth = (item: IMetaData, boxHeight: number) => {
  return computedWidth(item.width, item.height) + (boxHeight - 150);
};
